import { render } from "./MessageBox.vue?vue&type=template&id=e7317e16&scoped=true&ts=true"
import script from "./MessageBox.vue?vue&type=script&lang=ts"
export * from "./MessageBox.vue?vue&type=script&lang=ts"

import "./MessageBox.vue?vue&type=style&index=0&id=e7317e16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7317e16"]])

export default __exports__